@if (alerts.length > 0) {
  <section class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
    <div class="mb-2.5 flex items-center justify-between">
      <h2 class="text-lg font-semibold text-neutral-900 dark:text-white">Alertas de integração</h2>
      <div class="text-xs text-neutral-500 dark:text-neutral-400">
        {{ alerts.length }} {{ alerts.length === 1 ? 'alerta' : 'alertas' }}
      </div>
    </div>

    <div class="rounded-xl border border-rose-300/60 border-l-4 border-l-rose-500 bg-rose-50/60 px-3.5 py-2.5 dark:border-rose-700/60 dark:border-l-rose-500 dark:bg-rose-900/10">
      @for (alert of alerts; track $index) {
        <div class="grid grid-cols-[24px_1fr_auto] items-center gap-2.5 py-1.5 [&+&]:border-t [&+&]:border-dashed [&+&]:border-rose-300/40">
          <div class="inline-flex"
            [ngClass]="{
              'text-rose-500': alert.severity === 'error',
              'text-amber-500': alert.severity === 'warning',
              'text-blue-500': alert.severity === 'info'
            }">
            <i [innerHTML]="iconFor(alert.severity) | feather: { width: 16, height: 16 }"></i>
          </div>
          <div>
            <div class="text-sm font-semibold text-neutral-900 dark:text-white">{{ titleFor(alert.code) }}</div>
            <div class="mt-0.5 text-xs text-neutral-600 dark:text-neutral-400">{{ alert.message }}</div>
          </div>
          <div class="flex gap-1.5">
            @if (alert.code === 'INVOICE_PENDING' && isAllowedToReprocess && alert.showReprocessButton) {
              <app-button
                [icon]="reprocessIcon(reprocess)"
                size="small"
                color="warning"
                rounded="full"
                [disabled]="!reprocess.allowed"
                app-tool-tip
                [tooltip-text]="reprocessTooltip(reprocess)"
                (buttonClick)="onReprocessClick()">
              </app-button>
            }
          </div>
        </div>
      }
    </div>
  </section>
}
